import { GetEmoji, Emoji } from '@/core/constants';
import { ReactionType } from '@/types/apiServerContract';

export type ReactionTypes = keyof typeof ReactionType;

type ReactionIconMap = {
	[type in ReactionTypes]: Emoji;
};

export const ReactionIcons: ReactionIconMap = {
    Like: GetEmoji('thumb-up'),
    Heart: GetEmoji('<3'),
    Amazed: GetEmoji(':O'),
    Dislike: GetEmoji('thump-down')
};

export const GetReactionIcon = (type: ReactionType) => {
    return ReactionIcons[ReactionType[type] as ReactionTypes];
};

export const ReactionsMap = (): ReactionType[] => {
    return Object.values(ReactionType).filter(x => typeof x === 'number') as ReactionType[];
};
